import { array, date, object, string } from "yup";

const INVALID_COMPANY_NAME_REGEX =
  /^(?!$)(?!.*\b(?:PUBLIC LIMITED COMPANY|LIMITED|LTD|PLC|PVT|LLC|LP|Inc(?:\.|orporated)?|LLP|CLG)\b)/i;
const INVALID_COMPANY_NAME_ERROR =
  "Do not include the extension i.e. PUBLIC LIMITED COMPANY or PLC";
const DUPLICATE_COMPANY_NAME_ERROR = "Company name should be unique";

const companyValidation = ({
  dateOfChangeRequired,
  dateOfChangeOfFYRequired,
  cancellationDateRequired,
  strikeOffWithdrawalDateRequired,
  strikeOffApplicationTypeRequired,
  restorationDateRequired,
  isResistrationNameRequired,
  isApplicantsRequired,
}) =>
  object().shape({
    registrationName: string()
      .trim("Name cannot include leading and trailing spaces")
      .strict(true)
      .matches(INVALID_COMPANY_NAME_REGEX, INVALID_COMPANY_NAME_ERROR)
      .when([], {
        is: () => isResistrationNameRequired,
        then: (schema) => schema.required("Registration name is required"),
        otherwise: (schema) => schema,
      }),
    dateOfChange: date()
      .typeError("Date of change must be a valid date")
      .when([], {
        is: () => dateOfChangeRequired,
        then: (schema) =>
          schema.required("Date of change is required").nullable(),
        otherwise: (schema) => schema.nullable(),
      }),
    dateOfChangeOfFY: date()
      .typeError("Date of change of FY must be a valid date")
      .when([], {
        is: () => dateOfChangeOfFYRequired,
        then: (schema) =>
          schema.required("Date of change of FY is required").nullable(),
        otherwise: (schema) => schema.nullable(),
      }),
    cancellationDate: date()
      .typeError("Cancellation date must be a valid date")
      .when([], {
        is: () => cancellationDateRequired,
        then: (schema) =>
          schema.required("Cancellation date is required").nullable(),
        otherwise: (schema) => schema.nullable(),
      }),
    applicants: array().when([], {
      is: () => isApplicantsRequired,
      then: (schema) => schema.min(1, "Add applicant(s) is required"),
      otherwise: (schema) => schema,
    }),

    strikeOffWithdrawalDate: date()
      .typeError("Strike-off withdrawal date must be a valid date")
      .when([], {
        is: () => strikeOffWithdrawalDateRequired,
        then: (schema) =>
          schema.required("Strike-off withdrawal date is required").nullable(),
        otherwise: (schema) => schema.nullable(),
      }),

    strikeOffApplicationType: string()
      .when([], {
        is: () => strikeOffApplicationTypeRequired,
        then: (schema) =>
          schema.required("Strike-off application type is required"),
        otherwise: (schema) => schema,
      })
      .nullable(),

    restorationDate: date()
      .typeError("Restoration date must be a valid date")
      .when([], {
        is: () => restorationDateRequired,
        then: (schema) =>
          schema.required("Restoration date is required").nullable(),
        otherwise: (schema) => schema.nullable(),
      }),
  });

export default companyValidation;
